import { createContext } from 'react';

/**
 * `true` below a real next-intl provider (`ClientI18nProvider`). Without one,
 * `useText` renders the registered package English instead of throwing. Client
 * and SSR code only: server components never import this file (see `text.server.ts`).
 */
export const I18nReadyContext = createContext(false);
